module.exports = __webpack_public_path__ + "img/L_323_325.200af8dc.png";